/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import { Box, Button, Grid2, IconButton, Tooltip } from '@mui/material';
import getToken from 'helpers/auth';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import DeleteIcon from '@mui/icons-material/Delete';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { postForm } from 'js/actions/formsAction';
import { useDispatch } from 'react-redux';
import styles from './styles';

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from '@mui/material';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { DataGrid } from '@mui/x-data-grid';

const useStyles = makeStyles(styles);

export default function NavTabs(props) {
  const TIPO_FACTURACION = 4;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { register, handleSubmit } = useForm();

  const alert = props.alert || null;
  const dias_sem = ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom'];

  const [selectedDate, handleDateChange] = useState(new Date());
  const [selectedDate2, handleDateChange2] = useState(new Date());

  const [type, setType] = useState();

  const [days, setDays] = useState([]);

  const [types, setTypes] = useState([]);

  const [maxValue, setMaxValue] = useState('');

  const sendRules = (rules) => {
    if (rules == null || rules.length <= 0) {
      Swal.fire({
        title: 'Debe crear al menos una regla ',
        text: '',
        icon: 'error',
      });
      return;
    }
    dispatch(postForm(rules));
    props.nextStep();
  };

  const handleDelete = (id) => {
    setState((prevState) => ({
      ...prevState,
      data: prevState.data.filter((row) => row.id !== id),
    }));
  };

  const [state, setState] = useState({
    data: [],
    columns: [
      {
        headerName: 'Tipo',
        field: 'type',
        editable: true,
        renderCell: (rowData) => {
          if (rowData.row.type == 1) {
            return 'Corriente';
          } else if (rowData.row.type == 2) {
            return 'Potencia';
          } else if (rowData.row.type == 3) {
            return 'Voltaje';
          }
          if (rowData.row.type === TIPO_FACTURACION) {
            return 'Facturación';
          } else {
            return '';
          }
        },
        flex: 1,
      },
      {
        headerName: 'Días',
        field: 'days',
        editable: true,
        type: 'string',
        renderCell: (rowData) =>
          rowData.row.days
            ? rowData.row.days.map((d) => dias_sem[d - 1]).join(', ')
            : '',
        flex: 1,
      },
      {
        headerName: 'Valor Mínimo',
        field: 'min_value',
        editable: true,
        flex: 1,
      },
      {
        headerName: 'Valor Máximo',
        field: 'max_value',
        editable: true,
        flex: 1,
      },
      { headerName: 'Hora Inicio', field: 'hour_ini', editable: true, flex: 1 },
      { headerName: 'Hora Final', field: 'hour_end', editable: true, flex: 1 },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Actions',
        flex: 1,
        cellClassName: 'actions',
        renderCell: (rowData) => (
          <>
            <Tooltip title="Eliminar">
              <IconButton onClick={() => handleDelete(rowData.row.id)}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </>
        ),
      },
    ],
  });
  const [rule, setRule] = useState({
    data: [],
  });

  useEffect(() => {
    if (alert) {
      if (alert.rules) {
        setState({
          ...state,
          data: alert.rules,
        });
        setRule({
          ...state,
          data: alert.rules,
        });
      }
    }
    dispatch(loadCatalog());
  }, []);

  const loadCatalog = () => {
    return async () => {
      axios
        .get('https://api.metimur.mx/api/alerts/catalog', {
          headers: { Authorization: 'Bearer ' + getToken() },
        })
        .then((response) => {
          setTypes(response.data.data);
        })
        .catch((error) => {
          //dispatch(postUserAlertFail(error.message));
          console.log('ERROR API:' + error);
        });
    };
  };

  const onSubmit = (values, e) => {
    const arDays = Array.isArray(values.days) ? values.days : [];

    let obj = {
      id: state.data.length + 1,
      type: values.type,
      max_value: values.max_value,
      min_value: values.min_value,
      hour_ini: values.hour_ini,
      hour_end: values.hour_end,
      days: arDays,
    };

    setState({
      ...state,
      data: [...state.data, obj],
    });

    setRule({
      data: [...rule.data, obj],
    });

    e.target.reset();

    setType(null);
    setDays([]);
    handleDateChange(new Date());
    handleDateChange2(new Date());
  };

  const handleChangeMaxValue = (event) => {
    setMaxValue(event.target.value);
  };

  const handleChange = (event) => {
    setType(event.target.value);
  };

  const handleChangeDays = (event) => {
    setDays(event.target.value);
  };

  const renderDias = () => {
    if (type == 4) {
      return null;
    } else {
      return (
        <Grid2 size={2}>
          <FormControl className={classes.textField} required>
            <InputLabel id="demo-simple-select-label">Dias</InputLabel>
            <Select
              {...register('days')}
              labelId="demo-simple-select-disabled-label"
              multiple
              name="days"
              onChange={handleChangeDays}
              value={Object.values(days)}
            >
              <MenuItem value="">
                <em>Seleccionar Dias</em>
              </MenuItem>
              <MenuItem value={1}>Lunes</MenuItem>
              <MenuItem value={2}>Martes</MenuItem>
              <MenuItem value={3}>Miercoles</MenuItem>
              <MenuItem value={4}>Jueves</MenuItem>
              <MenuItem value={5}>Viernes</MenuItem>
              <MenuItem value={6}>Sabado</MenuItem>
              <MenuItem value={7}>Domingo</MenuItem>
            </Select>
          </FormControl>
        </Grid2>
      );
    }
  };

  const renderValorMinimo = () => {
    if (type == 4) {
      return null;
    } else {
      return (
        <Grid2 size={2}>
          <TextField
            className={classes.textField}
            {...register('min_value')}
            label="Valor Mínimo"
            name="min_value"
            required
            variant="outlined"
          />
        </Grid2>
      );
    }
  };

  const renderHoraIni = () => {
    if (type == 4) {
      return null;
    } else {
      return (
        <Grid2 size={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <TimePicker
              ampm={false}
              {...register('hour_ini')}
              label="Hora Inicial"
              name="hour_ini"
              onChange={(date) => handleDateChange(date)}
              value={selectedDate}
              sx={{ width: '100%' }}
            />
          </LocalizationProvider>
        </Grid2>
      );
    }
  };

  const renderHoraFin = () => {
    if (type == 4) {
      return null;
    } else {
      return (
        <Grid2 size={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <TimePicker
              ampm={false}
              {...register('hour_end')}
              label="Hora Final"
              name="hour_end"
              onChange={(date) => handleDateChange2(date)}
              value={selectedDate2}
              sx={{ width: '100%' }}
            />
          </LocalizationProvider>
        </Grid2>
      );
    }
  };

  return (
    <Grid2 container={true} my={3}>
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
        <Grid2 container={true} spacing={3}>
          <Grid2 size={2}>
            <FormControl className={classes.textField} required>
              <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
              <Select
                {...register('type')}
                labelId="demo-simple-select-disabled-label"
                name="type"
                onChange={handleChange}
                value={type}
              >
                <MenuItem value="">
                  <em>Seleccionar Tipo</em>
                </MenuItem>
                {types.map((t, index) => (
                  <MenuItem value={t.id} key={index}>
                    {t.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          {renderDias()}
          {renderValorMinimo()}
          <Grid2 size={2}>
            <TextField
              className={classes.textField}
              {...register('max_value')}
              label="Valor Máximo "
              name="max_value"
              onChange={handleChangeMaxValue}
              required
              value={maxValue}
              variant="outlined"
            />
          </Grid2>
          {renderHoraIni()}
          {renderHoraFin()}
          <Grid2 size={12}>
            <Button
              className={classes.textField}
              color="secondary"
              size="large"
              type="submit"
              variant="outlined"
            >
              Guardar Regla
            </Button>
          </Grid2>
        </Grid2>
      </form>
      <Box sx={{ height: 400, width: '100%', my: 3 }}>
        <DataGrid
          rows={state.data}
          columns={state.columns}
          getRowId={(row) => row.id}
          pageSize={5}
          sx={{
            pt: 2,
            pb: 2,
            borderRadius: 2,
            boxShadow: 3,
            backgroundColor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            '& .MuiDataGrid-root': { border: 'none' },
            '& .MuiDataGrid-cell': {
              borderBottom: '1px solid rgba(224, 224, 224, 1)',
              maxHeight: '60px',
            },
            '& .MuiDataGrid-columnHeaders': {
              borderBottom: '1px solid rgb(199, 199, 199)',
            },
            '& .MuiDataGrid-row': {
              borderBottom: '1px solid rgb(199, 199, 199)',
              maxHeight: '60px',
            },
          }}
        />
      </Box>

      <Button
        className={classes.textField}
        color="secondary"
        disabled={!rule.data.length}
        onClick={() => sendRules(rule.data)}
        size="large"
        sx={{ marginTop: '20px', width: '100%' }}
        variant="contained"
      >
        Guardar Y Continuar
      </Button>
    </Grid2>
  );
}
